module.exports = __webpack_public_path__ + "img/bim3.ed5bb6f8.png";